import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: 'newsletterConfig' }),
  fallback: belongsTo('newsletter-target', { inverse: null }),
  newsletterForms: hasMany('newsletter-form', { inverse: 'newsletterConfig' }),
});
